import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Bounds } from './data';

@Component({
  selector: 'bounds-control',
  template: `
    <div *ngIf="bounds" class="row">
      <div class="col-4"></div>
      <div class="col-4">
        <p>North</p>
        <input type="number" class="form-control" [(ngModel)]="bounds.north" [disabled]="readonly" (ngModelChange)="boundsEdited()">
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <p>West</p>
        <input type="number" class="form-control" [(ngModel)]="bounds.west" [disabled]="readonly" (ngModelChange)="boundsEdited()">
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <p>East</p>
        <input type="number" class="form-control" [(ngModel)]="bounds.east" [disabled]="readonly" (ngModelChange)="boundsEdited()">
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <p>South</p>
        <input type="number" class="form-control" [(ngModel)]="bounds.south" [disabled]="readonly" (ngModelChange)="boundsEdited()">
      </div>
    </div>
  `,
  styles: [
    `
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
  `
  ]
})
export class BoundsControlComponent implements OnInit {
  @Input() bounds: Bounds;
  @Input() readonly: boolean = false;
  @Output() boundsChanged = new EventEmitter<Bounds>();
  
  constructor() { }

  ngOnInit(): void {
  }

  boundsEdited(): void {
    this.boundsChanged.emit(this.bounds);
  }
}

